import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Grow from '@mui/material/Grow';
import Typography from '@mui/material/Typography';
import Logo from '../assets/img/logog.png'
import CardMedia from '@mui/material/CardMedia';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import Link from '@mui/material/Link';
import Formu from '../components/Formu'

export default function Contact(){

    return(
        <Box mt={8} pb={20} sx={{ width: '100%',
        backgroundColor: 'black' }} alignItems="center"
        justifyContent="center"
        style={{ backgroundColor: 'black' }}>

            <Box mb={10}>
                <Grow in={true} timeout={1000}>
                    <Typography gutterBottom variant="h3" sx={{color:'white',
                    paddingTop: 8,
                    fontFamily: 'Questrial', "&:hover":{color:'#4dd0e1'}}}>
                    Contact</Typography>
                </Grow>
            </Box>

            <Grid container spacing={1}
                alignItems="center"
                justifyContent="center"
                sx={{backgroundColor: 'black'}}
                >

                <Grid item xs={6} alignItems="center"
                justifyContent="center" pb={10}>

                <Grid item xs={4} alignItems="center"
                justifyContent="center">
                    <CardMedia 
                            component="img"
                            image={Logo}
                            alt="juli"
                            alignItems="center"
                        />
                </Grid>


                <Typography gutterBottom variant="h6" sx={{color:'white',
                    fontFamily: 'Questrial'}}>
                    Send me a message or follow me on social media</Typography>

                    <Link href="https://github.com/julianaquin">
                    <GitHubIcon sx={{color:"white", ml:2, textAlign:'center',
                    alignItems:"center",
                    justifyContent:"center"}} /></Link>

                    <Link href="https://www.linkedin.com/in/juliana-varela-q7">
                    <LinkedInIcon sx={{color:"white", ml:2}}/></Link>


                    

                </Grid>

                <Formu/>

            </Grid>
        </Box>
    )
};